'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



/*****************
 ** WEBPACK FOOTER
 ** ../~/query-string/~/strict-uri-encode/index.js
 ** module id = 1056
 ** module chunks = 3
 **/